(() => {
  const root = window.Shopify?.routes?.root || '/';
  const shirtId = 9174092251349;
  let busy = false, timer, checkedSubmit = false;
  const gift = item => item.product_id === shirtId && (item.properties?._mr === '1' || item.properties?._gtfo_free_shirt === 'outsiders');
  async function request(path, body) {
    const response = await fetch(root + path, body ? {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body)} : {cache:'no-store'});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Unable to update your gift.');
    return result;
  }
  function lock(value) {
    busy = value;
    document.querySelectorAll('#CartPageForm [name="checkout"], #CartDrawerForm [name="checkout"]').forEach(button => button.disabled = value);
  }
  async function normalize(cart) {
    const merchandise = cart.items.reduce((sum,item) => sum + (gift(item) || item.gift_card ? 0 : item.original_line_price), 0);
    let kept = false, changed = false;
    for (const item of cart.items.filter(gift)) {
      if (cart.currency !== 'USD' || merchandise < 19901 || kept || item.final_line_price !== 0) {
        cart = await request('cart/change.js', {id:item.key, quantity:0});
        changed = true;
      } else {
        kept = true;
        if (item.quantity !== 1) {
          cart = await request('cart/change.js', {id:item.key, quantity:1});
          changed = true;
        }
      }
    }
    if (changed) document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('gtfo:gift-cart', {detail:cart}));
    return cart;
  }
  async function sync() {
    if (busy || window.gtfoGiftReminder?.isAdding) return;
    lock(true);
    try { await normalize(await request('cart.js')); } catch (error) { console.warn('GTFO gift check:',error.message); }
    finally { lock(false); }
  }
  const schedule = () => {clearTimeout(timer);timer=setTimeout(sync,500);};
  ['cart:updated','cart:open','cart:build','ajaxProduct:added'].forEach(event => document.addEventListener(event,schedule));
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});
  document.querySelectorAll('#CartDrawerForm [data-products],#CartPageForm [data-products]').forEach(element=>new MutationObserver(schedule).observe(element,{childList:true}));
  document.addEventListener('submit',async event=>{
    const form=event.target;
    if(!form.matches('#CartDrawerForm,#CartPageForm'))return;
    if(checkedSubmit){checkedSubmit=false;return;}
    if(event.submitter?.name!=='checkout')return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if(busy)return;
    const submitter=event.submitter;
    lock(true);
    try {
      const cart = await normalize(await request('cart.js'));
      if (window.gtfoGiftReminder && !(await window.gtfoGiftReminder.confirm(cart))) { lock(false); return; }
      await normalize(await request('cart.js'));
      lock(false);checkedSubmit=true;form.requestSubmit(submitter);
    }
    catch(error){lock(false);let message=form.querySelector('[data-gtfo-gift-error]');if(!message){message=document.createElement('p');message.dataset.gtfoGiftError='';message.setAttribute('role','alert');submitter.before(message);}message.textContent='We could not check your free shirt. Please try checkout again.';}
  },true);
  schedule();
})();
